const customColors = {
    primary: '#ea6aa3',
    background: '#fde7f1',
    backgroundYellow: '#fefab6',
    white: '#ffffff',
}

export default customColors;